import { useEffect, useState } from "react";
import { Users, LogOut, Square } from "lucide-react";

function formatRemaining(endsAt) {
  const ms = new Date(endsAt).getTime() - Date.now();
  if (ms <= 0) return "expired";
  const m = Math.round(ms / 60000);
  if (m < 60) return `${m}m left`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return `${h}h ${rem}m left`;
}

export function HangoutBar({ hangout, members, selfId, onLeave, onEnd }) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((n) => n + 1), 30000);
    return () => clearInterval(t);
  }, []);
  if (!hangout) return null;
  const isHost = hangout.creator_id === selfId;
  return (
    <div data-testid="hangout-bar" className="mb-4 p-3 md:p-4 rounded-2xl border border-[#FF007F]/40 bg-[#FF007F]/[0.06] flex flex-col md:flex-row md:items-center gap-3">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className="relative w-10 h-10 rounded-full bg-[#FF007F]/20 border border-[#FF007F]/60 flex items-center justify-center shrink-0">
          <Users size={16} className="text-[#FF007F]" />
          <span className="absolute inset-0 rounded-full border border-[#FF007F]/60 animate-ping" />
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-[10px] tracking-[0.3em] font-mono text-[#FF007F]">// HANGOUT LIVE</span>
            <span className="text-[10px] font-mono text-white/40">· {tick >= 0 && formatRemaining(hangout.ends_at)}</span>
          </div>
          <div className="font-[Unbounded] text-sm md:text-base truncate">{hangout.name}</div>
          <div data-testid="hangout-members-line" className="text-xs text-white/60 truncate">
            {members.map((m) => m.display_name || "…").join(" · ")}
          </div>
        </div>
      </div>
      <div className="flex gap-2 shrink-0">
        {isHost && (
          <button data-testid="end-hangout-btn" onClick={onEnd}
            className="inline-flex items-center gap-1 border border-[#FF007F]/40 text-[#FF007F] text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#FF007F] hover:text-black transition-all">
            <Square size={12} /> End
          </button>
        )}
        {!isHost && (
          <button data-testid="leave-hangout-btn" onClick={onLeave}
            className="inline-flex items-center gap-1 border border-white/15 text-white/70 text-xs font-semibold px-3 py-1.5 rounded-full hover:border-[#FF007F] hover:text-[#FF007F] transition-all">
            <LogOut size={12} /> Leave
          </button>
        )}
      </div>
    </div>
  );
}
